import qrcode from 'qrcode-generator';

/**
 * QR as inline SVG — it scales to any phone screen and needs no canvas sizing
 * dance. Error-correction level M survives a fingerprint on the glass.
 */
export function qrSvg(text: string): string {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  return qr.createSvgTag({ cellSize: 4, margin: 1, scalable: true });
}
